/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getAccountMessageUsage(month) {
    return axios.get(`${this.baseUrl()}/whatsapp_message_usage`, {
      params: { month },
    });
  }

  getMessageUsage(inboxId, month) {
    return axios.get(`${this.url}/${inboxId}/message_usage`, {
      params: { month },
    });
  }

  updateMessageUsageSettings(inboxId, settings) {
    return axios.patch(`${this.url}/${inboxId}/message_usage_settings`, {
      settings,
    });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  getBusinessProfile(inboxId) {
    return axios.get(`${this.url}/${inboxId}/business_profile`);
  }

  updateBusinessProfile(inboxId, profile) {
    return axios.patch(`${this.url}/${inboxId}/business_profile`, { profile });
  }

  updateBusinessProfilePicture(inboxId, file) {
    const data = new FormData();
    data.append('file', file);
    return axios.post(`${this.url}/${inboxId}/business_profile_picture`, data);
  }

  getBusinessUsernameSuggestions(inboxId) {
    return axios.get(`${this.url}/${inboxId}/business_username_suggestions`);
  }

  requestBusinessUsername(inboxId, username) {
    return axios.post(`${this.url}/${inboxId}/business_username`, { username });
  }

  requestPhoneVerification(inboxId) {
    return axios.post(`${this.url}/${inboxId}/request_phone_verification`);
  }

  verifyPhoneCode(inboxId, code) {
    return axios.post(`${this.url}/${inboxId}/verify_phone_code`, { code });
  }

  getCoexistenceSync(inboxId) {
    return axios.get(`${this.url}/${inboxId}/coexistence_sync`);
  }

  requestCoexistenceSync(inboxId) {
    return axios.post(`${this.url}/${inboxId}/request_coexistence_sync`);
  }

  // Histórico anterior à conexão (Instagram e Messenger): ler o estado não chama a Meta.
  getHistoryImport(inboxId) {
    return axios.get(`${this.url}/${inboxId}/history_import`);
  }

  requestHistoryImport(inboxId) {
    return axios.post(`${this.url}/${inboxId}/history_import`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  getMessageLinks(inboxId) {
    return axios.get(`${this.url}/${inboxId}/message_links`);
  }

  deleteMessageLink(inboxId, code) {
    return axios.delete(`${this.url}/${inboxId}/message_links`, {
      params: { code },
    });
  }

  createMessageLink(inboxId, prefilledMessage) {
    return axios.post(`${this.url}/${inboxId}/message_links`, {
      prefilled_message: prefilledMessage,
    });
  }
}

export default new InboxHealthAPI();
